var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_5069_39126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3856 20.5401C26.9389 19.0888 25.1832 17.9307 23.2292 17.1386C21.2751 16.3464 19.1651 15.9375 17.032 15.9375C14.8988 15.9375 12.7888 16.3464 10.8348 17.1386C8.88074 17.9307 7.12506 19.0888 5.67829 20.5401C5.45493 20.7687 5.32998 21.0654 5.32715 21.3736V26.375C5.33188 26.7038 5.47626 27.0175 5.72903 27.2484C5.98179 27.4793 6.32261 27.6088 6.6777 27.6087H27.3862C27.7444 27.6087 28.0879 27.477 28.3412 27.2425C28.5945 27.008 28.7368 26.69 28.7368 26.3584V21.357C28.7296 21.0545 28.6049 20.7644 28.3856 20.5401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0318 14.2754C20.5127 14.2754 23.3344 11.663 23.3344 8.44043C23.3344 5.21787 20.5127 2.60547 17.0318 2.60547C13.551 2.60547 10.7292 5.21787 10.7292 8.44043C10.7292 11.663 13.551 14.2754 17.0318 14.2754Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5069_39126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4133,
    height: 30.0084,
    fill: "white",
    transform: "translate(0.825195 0.101562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultuser);
export default __webpack_public_path__ + "static/media/defaultuser.5ef58edb7eed8ebf275a59cb3b17d39d.svg";
export { ForwardRef as ReactComponent };